import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { reset, change } from "redux-form";
import { issueCertificate } from "./actions";
import Alert from "shared/components/Alert";

import EmissionForm from "../../components/EmissionForm";
import { useParams } from "react-router";

function Emission() {
	const dispatch = useDispatch();

	const params = useParams();

	const [message, setMessage] = useState("");

	const [loading, setLoading] = useState(false);

	const handleDismiss = () => {
		setMessage("");
	};

	const onSubmit = async (values, setPage) => {
		setLoading(true);

		const data = {
			...values,
			knowAbout:
				values.knowAbout?.value === "Outros"
					? values.knowAboutOther
					: values.knowAbout?.value,
			events: undefined,
			event: undefined,
			loading: undefined
		};

		let type = "";

		switch (params?.type) {
			case "palestrante":
				type = 0;
				break;
			default:
				break;
		}

		dispatch(
			issueCertificate(data, type, (err, blob) => {
				if (err) {
					console.log(err);
					alert(err && JSON.stringify(err));
				} else {
					dispatch(reset("certificate_emission"));
					const url = window.URL.createObjectURL(
						new Blob([blob], { type: "application/pdf" })
					);
					window.open(url, "_blank");

					setPage(1);
				}

				setLoading(false);
			})
		);
	};

	return (
		<>
			{message && (
				<div
					style={{
						position: "absolute",
						right: 16,
						top: 16
					}}
				>
					<Alert
						color="warning"
						className="alert--bordered"
						icon
						onDismiss={handleDismiss}
					>
						<p>
							<span className="bold-text">{message}</span>
						</p>
					</Alert>
				</div>
			)}
			<div className="account">
				<div className="account__wrapper">
					<div className="account__card">
						<div className="account__head">
							<div className="account__sub_logo" />
						</div>
						<EmissionForm
							onSubmit={onSubmit}
							loading={loading}
							type={params?.type}
						/>
						<div
							className="account__logo__head"
							style={{ marginBottom: 8, justifyContent: "space-evenly" }}
						>
							<div className="account__logo" />
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
export default Emission;
